import { render, staticRenderFns } from "./SolicitudFederal.vue?vue&type=template&id=0c6e7b13"
import script from "./SolicitudFederal.vue?vue&type=script&lang=js"
export * from "./SolicitudFederal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports